import React from 'react';

function BookmarkAddedIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_11970_168364" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_11970_168364)">
        <path
          d="M5.5 20.25V5.3C5.5 4.8 5.675 4.375 6.025 4.025C6.375 3.675 6.8 3.5 7.3 3.5H16.7C17.2 3.5 17.625 3.675 17.975 4.025C18.325 4.375 18.5 4.8 18.5 5.3V20.25L12 17.45L5.5 20.25Z"
          fill="#1C73FF"
        />
      </g>
    </svg>
  );
}

export default BookmarkAddedIcon;
